const Dp = [
    {
      Topic: "Dynamic Programming",
      Problem: "Coin ChangeProblem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/coin-change2448/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/ways-to-make-coin-change_630471?topList=love-babbar-dsa-sheet-problems",
      Id: 1
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Knapsack Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/0-1-knapsack-problem/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/0-1-knapsack_920542?topList=love-babbar-dsa-sheet-problems",
      Id: 2
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Binomial CoefficientProblem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/ncr1019/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/binomial-coefficient-problem_1229410?topList=love-babbar-dsa-sheet-problems",
      Id: 3
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Permutation CoefficientProblem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/permutation-coefficient/",
      URL2: "https://www.codingninjas.com/codestudio/problems/permutationcoefficient_1214975?topList=love-babbar-dsa-sheet-problems",
      Id: 4
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Program for nth Catalan Number",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/geek-and-his-binary-strings1951/1/",
      URL2: "https://www.codingninjas.com/codestudio/problems/catalan-number_893076?topList=love-babbar-dsa-sheet-problems",
      Id: 5
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Matrix Chain Multiplication ",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/matrix-chain-multiplication0303/1/",
      URL2: "https://www.codingninjas.com/codestudio/problems/matrix-chain-multiplication_975344?topList=love-babbar-dsa-sheet-problems",
      Id: 6
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Edit Distance",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/edit-distance3702/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/edit-distance_630420?topList=love-babbar-dsa-sheet-problems",
      Id: 7
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Subset Sum Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
      URL2: "",
      Id: 8
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Friends Pairing Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/friends-pairing-problem5425/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/friends-pairing-problem_1214625?topList=love-babbar-dsa-sheet-problems",
      Id: 9
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Gold Mine Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/gold-mine-problem2608/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/gold-mine-problem_799363?topList=love-babbar-dsa-sheet-problems",
      Id: 10
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Assembly Line SchedulingProblem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/assembly-line-scheduling-dp-34/",
      URL2: "https://www.codingninjas.com/codestudio/problems/minimum-time-to-cross-all-checkpoints_1214626?topList=love-babbar-dsa-sheet-problems",
      Id: 11
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Painting the Fenceproblem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/painting-the-fence3727/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/ninja-and-the-fence_3210208?topList=love-babbar-dsa-sheet-problems",
      Id: 12
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Maximize The Cut Segments",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/cutted-segments/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/cut-into-segments_1214651?topList=love-babbar-dsa-sheet-problems",
      Id: 13
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Longest Common Subsequence",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/longest-common-subsequence/0",
      URL2: "",
      Id: 14
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Longest Repeated Subsequence",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/longest-repeating-subsequence/0",
      URL2: "",
      Id: 15
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Longest Increasing Subsequence",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/longest-increasing-subsequence/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/longest-increasing-subsequence_630459?topList=love-babbar-dsa-sheet-problems",
      Id: 16
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Space Optimized Solution of LCS",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/space-optimized-solution-lcs/",
      URL2: "",
      Id: 17
    },
    {
      Topic: "Dynamic Programming",
      Problem: "LCS (Longest Common Subsequence) of three strings",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/lcs-of-three-strings/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/lcs-of-3-strings_893011?topList=love-babbar-dsa-sheet-problems",
      Id: 18
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Maximum Sum Increasing Subsequence",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/maximum-sum-increasing-subsequence4749/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/ninja-at-the-gym_1112624?topList=love-babbar-dsa-sheet-problems",
      Id: 19
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Count all subsequences having product less than K",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/count-subsequences-product-less-k/",
      URL2: "https://www.codingninjas.com/codestudio/problems/count-the-number-of-subsequences-having-product-not-more-than-p_1214647?topList=love-babbar-dsa-sheet-problems",
      Id: 20
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Longest subsequence such that difference between adjacent is one",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/longest-subsequence-such-that-difference-between-adjacents-is-one4724/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/longest-subsequence-with-difference-one_1214549?topList=love-babbar-dsa-sheet-problems",
      Id: 21
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Maximum subsequence sum such that no three are consecutive",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/max-sum-without-adjacents-2/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-subsequence-sum-such-that-no-three-are-consecutive_1215007?topList=love-babbar-dsa-sheet-problems",
      Id: 22
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Egg Dropping Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/egg-dropping-puzzle/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/cut-logs_982770?topList=love-babbar-dsa-sheet-problems",
      Id: 23
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Maximum Length Chain of Pairs",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/max-length-chain/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-length-pair-chain_985258?topList=love-babbar-dsa-sheet-problems",
      Id: 24
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Maximum size square sub-matrix with all 1s",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/largest-square-formed-in-a-matrix/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-area-square_981268?topList=love-babbar-dsa-sheet-problems",
      Id: 25
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Maximum sum of pairs with specific difference",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/pairs-with-specific-difference/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-sum-of-pairs-with-specific-difference_1230548?topList=love-babbar-dsa-sheet-problems",
      Id: 26
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Min Cost PathProblem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/path-in-matrix3805/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/min-cost-path_842565?topList=love-babbar-dsa-sheet-problems",
      Id: 27
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Maximum difference of zeros and ones in binary string",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/maximum-difference-of-zeros-and-ones-in-binary-string4111/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-difference-of-zeros-and-ones-in-a-binary-string_1203919?topList=love-babbar-dsa-sheet-problems",
      Id: 28
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Minimum number of jumps to reach end",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/minimum-number-of-jumps/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/jump-game_893178?topList=love-babbar-dsa-sheet-problems",
      Id: 29
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Minimum cost to fill given weight in a bag",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/minimum-cost-to-fill-given-weight-in-a-bag1956/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/minimum-cost-to-buy-rice_3210212?topList=love-babbar-dsa-sheet-problems",
      Id: 30
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Minimum removals from array to make max –min <= K",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/minimum-removals-array-make-max-min-k/",
      URL2: "https://www.codingninjas.com/codestudio/problems/minimum-removals_1214550?topList=love-babbar-dsa-sheet-problems",
      Id: 31
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Longest Common Substring",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/longest-common-substring/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/longest-common-substring_1235207?topList=love-babbar-dsa-sheet-problems",
      Id: 32
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Count number of ways to reacha given score in a game",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/reach-a-given-score/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/ninja-and-his-exam_1214657?topList=love-babbar-dsa-sheet-problems",
      Id: 33
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Count Balanced Binary Trees of Height h",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/bbt-counter/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/number-of-balanced-binary-trees_1062690?topList=love-babbar-dsa-sheet-problems",
      Id: 34
    },
    {
      Topic: "Dynamic Programming",
      Problem: "LargestSum Contiguous Subarray [V>V>V>V IMP ]",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0",
      URL2: "",
      Id: 35
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Smallest sum contiguous subarray",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/smallest-sum-contiguous-subarray/",
      URL2: "https://www.codingninjas.com/codestudio/problems/minimum-sum-subarray_1062622?topList=love-babbar-dsa-sheet-problems",
      Id: 36
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Unbounded Knapsack (Repetition of items allowed)",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/knapsack-with-duplicate-items4201/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/unbounded-knapsack_1215029?topList=love-babbar-dsa-sheet-problems",
      Id: 37
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Word Break Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/word-break/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/ninja-the-exam-instructor_1215010?topList=love-babbar-dsa-sheet-problems",
      Id: 38
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Largest Independent Set Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/largest-independent-set-problem-dp-26/",
      URL2: "",
      Id: 39
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Partition problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/partition_1172151?topList=love-babbar-dsa-sheet-problems",
      Id: 40
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Longest Palindromic Subsequence",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/longest-palindromic-subsequence-1612327878/1/",
      URL2: "https://www.codingninjas.com/codestudio/problems/longest-palindromic-subsequence_842787?topList=love-babbar-dsa-sheet-problems",
      Id: 41
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Count All Palindromic Subsequence in a given String",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/count-palindromic-subsequences/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/count-palindromic-subsequences_1062696?topList=love-babbar-dsa-sheet-problems",
      Id: 42
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Longest Palindromic Substring",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://leetcode.com/problems/longest-palindromic-substring/",
      URL2: "",
      Id: 43
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Longest alternating subsequence",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/longest-alternating-subsequence/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/longest-alternating-subsequence_1214645?topList=love-babbar-dsa-sheet-problems",
      Id: 44
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Weighted Job Scheduling",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/weighted-job-scheduling/",
      URL2: "",
      Id: 45
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Coin game winner where every player has three choices",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/coin-game-winner-every-player-three-choices/",
      URL2: "https://www.codingninjas.com/codestudio/problems/coin-game-winner-where-every-player-has-three-choices_1229492?topList=love-babbar-dsa-sheet-problems",
      Id: 46
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Count Derangements (Permutation such that no element appears in its original position) [ IMPORTANT ]",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/count-derangements-permutation-such-that-no-element-appears-in-its-original-position/",
      URL2: "https://www.codingninjas.com/codestudio/problems/count-derangements_1199092?topList=love-babbar-dsa-sheet-problems",
      Id: 47
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Maximum profit by buying and selling a share at most twice [ IMP ]",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/maximum-profit-by-buying-and-selling-a-share-at-most-twice/",
      URL2: "",
      Id: 48
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Optimal Strategy for a Game",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/optimal-strategy-for-a-game/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/optimal-strategy-for-a-game_975479?topList=love-babbar-dsa-sheet-problems",
      Id: 49
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Optimal Binary Search Tree",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/optimal-binary-search-tree-dp-24/",
      URL2: "https://www.codingninjas.com/codestudio/problems/minimum-cost-bst_3210619?topList=love-babbar-dsa-sheet-problems",
      Id: 50
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Palindrome PartitioningProblem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/palindromic-patitioning4845/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/palindromic-partitioning_1063252?topList=love-babbar-dsa-sheet-problems",
      Id: 51
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Word Wrap Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/word-wrap/0",
      URL2: "",
      Id: 52
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Mobile Numeric Keypad Problem [ IMP ]",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/mobile-numeric-keypad5456/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/mike-and-mobile_1082139?topList=love-babbar-dsa-sheet-problems",
      Id: 53
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Boolean Parenthesization Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/boolean-parenthesization/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/problem-name-boolean-evaluation_1214650?topList=love-babbar-dsa-sheet-problems",
      Id: 54
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Largest rectangular sub-matrix whose sum is 0",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/largest-rectangular-sub-matrix-whose-sum-0/",
      URL2: "https://www.codingninjas.com/codestudio/problems/sub-matrix-with-sum-zero_1063254?topList=love-babbar-dsa-sheet-problems",
      Id: 55
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Largest area rectangular sub-matrix with equal number of 1’s and 0’s [ IMP ]",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/largest-area-rectangular-sub-matrix-equal-number-1s-0s/",
      URL2: "https://www.codingninjas.com/codestudio/problems/largest-sub-matrix-with-equal-0-s-and-1-s_3210616?topList=love-babbar-dsa-sheet-problems",
      Id: 56
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Maximum sum rectangle in a 2D matrix",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/maximum-sum-rectangle/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-sum-rectangle_875115?topList=love-babbar-dsa-sheet-problems",
      Id: 57
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Maximum profit by buying and selling a share at most k times",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/maximum-profit4657/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/best-time-to-buy-and-sell-stock_1080698?topList=love-babbar-dsa-sheet-problems",
      Id: 58
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Find if a string is interleaved of two other strings",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/interleaved-strings/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/interleaving-two-strings_1062567?topList=love-babbar-dsa-sheet-problems",
      Id: 59
    },
    {
      Topic: "Dynamic Programming",
      Problem: "Maximum Length of Pair Chain",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://leetcode.com/problems/maximum-length-of-pair-chain/",
      URL2: "",
      Id: 60
    }
  ];

export default Dp;